/**
 * @licence Copyright © 2019 Mercury Redstone BV, all rights reserved
 */
import { useCallback, type Ref, type RefObject } from 'react';

export const useCombinedRef = <T>(...refs: Array<Ref<T> | undefined>) =>
  useCallback(
    (element: T | null) => {
      refs.forEach((ref) => {
        if (!ref) return;
        if (typeof ref === 'function') {
          ref(element);
        } else if ('current' in ref) {
          (ref as RefObject<T | null>).current = element;
        }
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  );
